<template>
	<div class="templates">
		<md-field class="md-field-margin">
			<label>Template Name:</label>
			<md-input v-model="template.name" name="name" v-validate="'required|max:60'" @input="sanitizeName"></md-input>
		</md-field>
        <p v-show="errors.has('name')" v-text="errors.first('name')" class="error"></p>
		<md-field class="md-field-margin">
			<label>Description:</label>
			<md-input v-model="template.description" name="description" v-validate="'required|max:100'" @input="sanitizeDescription"></md-input>
		</md-field>
        <p class="error" v-show="errors.has('description')" v-text="errors.first('description')"></p>
        <md-field class="md-field-margin">
			<label>Reference Id:</label>
			<md-input v-model="template.ref_id" disabled></md-input>
		</md-field>
		<md-field class="md-field-margin">
			<label>Body:</label>
			<md-textarea v-model="template.body" name="body" v-validate="'required'" @input="sanitizeBody"></md-textarea>
		</md-field>
        <p class="error" v-show="errors.has('body')" v-text="errors.first('body')"></p>
		<md-field class="md-field-margin">
			<label>SMS Category:</label>
			<md-select v-model="template.category" name="category"  v-validate="'required'" placeholder="SMS category" id="category">
				<md-option value="None">None (no category)</md-option>
				<md-option value="noFollowUp">No Follow Up</md-option>
			</md-select>
		</md-field>
			<p class="error" v-show="errors.has('category')" v-text="errors.first('category')"></p>
		<md-field class="md-field-margin">
			<md-button class="md-raised md-round md-accent" @click="save">{{ saveText }}</md-button>
			<md-button class="md-raised md-round md-accent m-left-20" @click="deleteTemplate()">Delete</md-button>
		</md-field>
	</div>
</template>
<!-- Script-->
<script>
import API from "../services/API";
import { sanitizeInput } from '../utils/sanitizer';
export default {
  	props: ["template_id"],
  	data() {
	    return {
	      	api: new API(),
	      	saveText: "save",
	      	template: {},
	      	fullPage: true
	    };
  	},
  	watch: {
    	$route: "loadData"
  	},
  	created() {
		this.loadData();
	},
  	methods: {
		sanitizeName(value) {
            this.template.name = sanitizeInput(value);
        },
        sanitizeDescription(value) {
            this.template.description = sanitizeInput(value);
        },
        sanitizeBody(value) {
            this.template.body = sanitizeInput(value);
        },
	    loadData: async function() {
	      	this.saveText = "save";
	      	await this.api.get(`sms-templates/${this.template_id}`).then(template => {
	        	this.template = template.data;
	      	});
	    },
	    save: async function() {
	    	this.$validator.validateAll().then(async (result) => {
	    		if (result) {
			      	await this.api
			        .put(`sms-templates/${this.template_id}`, this.template)
			        .then(template => {
			          this.$emit("reload");
			          this.saveText = "saved";
			          this.template = template.data;
			        });
		        }
		    }).catch(err => {
		    	return new Promise((resolve, reject) => {
		    		resolve(err);
		    	});
		    });
	    },
	    async deleteTemplate() {
	    	await this.api.put(`sms-templates/${this.template_id}/delete`, { deleted: true }).then(template => {
				this.$emit("reload");
	          	this.$router.push('/');
	        });
	    }
  	}
};
</script>



// WEBPACK FOOTER //
// src/components/SmsTemplate.vue